export enum MarketingSubscriptionOption {
  WAITROSE = 'waitrose',
  MY_WAITROSE = 'mywaitrose',
  JOHN_LEWIS = 'johnlewis',
  JOHN_LEWIS_FINANCIAL_SERVICES = 'johnlewisfinancialservices',
}
